import { InitiateAuthResponse, RefreshTokenResponse } from '@/types/auth';
import { deepLinkHandler } from '@/utils/deepLinkHandler';
import { create } from 'zustand';

type UseAuthUserState = {
  isStaff: boolean;
  accessToken: RefreshTokenResponse | null;
  authUser: InitiateAuthResponse | null;
  postLoginScreen: string;
  setIsStaff: (data: boolean) => void;
  setAuthUser: (data: InitiateAuthResponse | null) => void;
  setPostLoginScreen: (route: string) => void;
};

export const useAuthUser = create<UseAuthUserState>(set => {
  return {
    isStaff: window.location.hostname.includes('staff') || false,
    authUser: null,
    accessToken: null,
    postLoginScreen: '',
    setIsStaff: data => {
      set({ isStaff: data });
    },
    setAuthUser: authUser => {
      set({ authUser });
    },
    setPostLoginScreen: postLoginScreen => {
      set({ postLoginScreen: deepLinkHandler(postLoginScreen) });
    },
  };
});
